import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import Nav from "@/components/dw/Nav";
import Footer from "@/components/dw/Footer";
import WhatsAppFab from "@/components/dw/WhatsAppFab";
import { api } from "@/lib/api";
import { ArrowLeft } from "lucide-react";

export default function BlogPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [notFound, setNotFound] = useState(false);
  useEffect(() => {
    api.get(`/blog/${slug}`).then((r) => setPost(r.data)).catch(() => setNotFound(true));
  }, [slug]);

  return (
    <div>
      <Nav />
      <main className="py-12 md:py-20">
        <div className="max-w-3xl mx-auto px-5 md:px-8">
          <Link to="/" data-testid="blog-back" className="inline-flex items-center gap-2 text-sm font-semibold" style={{ color: "var(--primary)" }}>
            <ArrowLeft size={16} /> Back to home
          </Link>
          {notFound && <div className="mt-10 text-lg">Post not found.</div>}
          {post && (
            <article className="mt-8" data-testid="blog-article">
              <div className="flex gap-2 flex-wrap">
                {(post.tags || []).map((tag) => (
                  <span key={tag} className="text-[10px] font-semibold uppercase tracking-widest px-2.5 py-1 rounded-full" style={{ background: "var(--bg-paper)", color: "var(--primary)" }}>
                    {tag}
                  </span>
                ))}
              </div>
              <h1 className="mt-4 font-display text-4xl md:text-6xl leading-tight" style={{ color: "var(--primary)" }}>{post.title}</h1>
              <p className="mt-4 text-lg" style={{ color: "var(--text-secondary)" }}>{post.excerpt}</p>
              {post.image_url && (
                <div className="mt-8 rounded-[24px] overflow-hidden">
                  <img src={post.image_url} alt={post.title} className="w-full h-[400px] object-cover" />
                </div>
              )}
              <div className="mt-8 text-lg leading-relaxed whitespace-pre-wrap" style={{ color: "var(--text-primary)" }}>{post.content}</div>
            </article>
          )}
        </div>
      </main>
      <Footer />
      <WhatsAppFab />
    </div>
  );
}
